<script>
import { mapState, mapActions } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryPersonCategoryEdit',
  mixins: [validatorMixin],
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      validForm: true,
      current: undefined,
    };
  },
  computed: {
    ...mapState({
      personCategory: state => state.transportation.personCategories.personCategory,
      saveError: state => state.transportation.personCategories.saveError,
      saveLoading: state => state.transportation.personCategories.saveLoading,
    }),
    changesMade() {
      const changes = JSON.stringify(this.current) !== JSON.stringify(this.personCategory);
      this.$emit('input', changes);
      return changes;
    },
  },
  methods: {
    ...mapActions({
      savePersonCategory: 'transportation/savePersonCategory',
    }),
    saveEditPersonCategory() {
      if (this.validForm) {
        this.savePersonCategory(this.current)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.current = { ...this.personCategory };
        this.$emit('input', this.changesMade);
      }
    },
  },
};
</script>

<template>
  <v-card v-if="personCategory && current">
    <v-form v-model="validForm" @submit.prevent="saveEditPersonCategory">
      <v-card-title>
        <span class="headline">
          Edit Person Category
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :indeterminate="true"
          :height="4"
          class="my-0"
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          transition="slide-y-transition"
          class="my-0 py-2"
          outline
        >
          An error occurred while saving
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.fromAge"
                :rules="[rules.requiredNumber]"
                :disabled="saveLoading"
                type="number"
                label="Age from"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.toAge"
                :rules="[rules.requiredNumber]"
                :disabled="saveLoading"
                type="number"
                label="Age to"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                hint="External ref is used to identify the person category against suppliers system"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="current.active"
                :disabled="saveLoading"
                label="Active"
                hide-details
                class="mt-0"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Close
        </v-btn>
        <v-tooltip top>
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading"
                color="blue darken-1"
                type="submit"
                flat
              >
                Save
              </v-btn>
            </div>
          </template>
          <span>
            No changes has been made
          </span>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationPersonCategoryEdit.vue